<template>
  <div class="dashboard-home">
    <p>대시보드</p>
    <p class="dashboard-home__hint">
      우측 상단 ☰ 로 메뉴를 열 수 있습니다. (모듈 이식 후 표시)
    </p>
  </div>
</template>

<script>
export default {
  name: "DashboardHome",
};
</script>

<style scoped>
.dashboard-home__hint {
  color: #ffffff80;
  font-size: 14px;
  margin-top: 8px;
}
</style>
